<template>
  <div v-if="data" class="ps">
    <div ref="productSlider" class="ps__products-wrapper swiper-container">
      <div class="ps__products">
        <div v-for="(product, index) in data.products" :key="index" class="ps__product">
          <ProductCard
            type="TypeA"
            :product="data.isDefaultVariant ? product.product : product"
            :gtmTrackId="data.gtmTrackId"
            :isLoadingLazy="true"
            :isTrackClickEvent="data?.isTrackClickEvent"
            :showWishlistIcon="false"
            v-bind="data.isDefaultVariant ? { selectedColorValue: product.selectedFirstOption } : {}"
          />
        </div>
      </div>
      <div class="ps__nav ps__prev" tabindex="0">
        <svg class="ps__prev-icon">
          <use xlink:href="#icon-prev"></use>
        </svg>
      </div>
      <div class="ps__nav ps__next" tabindex="0">
        <svg class="ps__next-icon">
          <use xlink:href="#icon-next"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup="props">
  import { computed, toRefs, ref, onMounted } from 'vue';
  import ProductCard from '../global/product-card/index.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, A11y } from 'swiper/core';
  import { useMediaType } from '../../utils/use-media-type';
  import { MEDIA_TYPES } from '../../utils/constants';

  SwiperCore.use([Navigation, A11y]);

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    },
  });

  const { data } = toRefs(props);
  const mediaType = useMediaType();

  onMounted(() => {
    new Swiper(productSlider.value, productCarousel.value);
    window.refreshYotpoData();

    if (enableSlideAnimation(mediaType.value)) {
      callSlideAnimation();
    }
  });

  var productSlider = ref(null);

  const productCarousel = computed(() => {
    return {
      slidesPerView: data.value.slidesPerViewMobile,
      spaceBetween: 16,
      wrapperClass: 'ps__products',
      slideClass: 'ps__product',
      threshold: 6, // will get swiped only when drag is atleast 6px
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 2.8,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: data.value.slidesPerViewDesktop,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: '.ps__next',
        prevEl: '.ps__prev',
      },
      a11y: {
        enabled: true,
      },
    };
  });

  const enableSlideAnimation = (mediaType) => {
    const isDesktop = [MEDIA_TYPES.TABLET_EXTRA_LARGE, MEDIA_TYPES.DESKTOP, MEDIA_TYPES.DESKTOP_LARGE].includes(
      mediaType
    );
    const isMobile = [
      MEDIA_TYPES.MOBILE,
      MEDIA_TYPES.MOBILE_LARGE,
      MEDIA_TYPES.TABLET,
      MEDIA_TYPES.TABLET_LARGE,
    ].includes(mediaType);

    return (data.value.enableSlideAnimationDesktop && isDesktop) || (data.value.enableSlideAnimationMobile && isMobile);
  };

  const callSlideAnimation = () => {
    const container = productSlider.value;

    // Set initial styles directly
    container.style.opacity = '0';
    container.style.transform = 'translateX(100%)';
    container.style.transition = 'transform 2s ease, opacity 2s ease';

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Update styles to trigger the animation
          container.style.opacity = '1'; // Fade in
          container.style.transform = 'translateX(0)'; // Move to original position
          observer.unobserve(entry.target); // Stop observing once it becomes visible
        }
      });
    });

    observer.observe(container); // Observe the current swiper container
  };
</script>
